<template>
  <v-container class="cmpbk black--text" id="help-dialog-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <v-dialog
      v-model="dialog"
      scrollable
      max-width="1200px"
      :overlay-opacity="0.7"
      persistent
    >
      <v-card max-height="1200px" class="backdrop dialog-card help-card">
        <v-card-title class="backdrop lighten-1 dialog-title">
          <span v-if="this.current_help_page_record == null" class="text-h5"
            >Help</span
          >
          <span v-else class="text-h5">
            {{ this.current_help_page_record.title }}</span
          >
        </v-card-title>
        <v-card-text class="backdrop pa-0 white--text">
          <v-container>
            <component :is="current_help_page_component"></component>
          </v-container>
        </v-card-text>

        <v-card-actions class="backdrop lighten-1 border-card">
          <v-spacer></v-spacer>
          <v-btn color="secondary" class="black--text" @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style lang="scss" scoped>
.dialog-title {
  margin-bottom: 2px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px,
    rgba(0, 0, 0, 0.22) 0px 10px 10px;
}

.custom-divider {
  height: 2px;
  background-color: black;
}

.border-card {
  margin: 2px;
}

.help-card {
  .container {
    max-width: none;
    padding: 24px;

    ::v-deep h2 {
      margin-bottom: 10px;
    }
    ::v-deep .help-image {
      margin-bottom: 15px;
    }
    ::v-deep .help-image-style {
      //border: 1px solid black;
      //box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    }
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import { help_content_components } from "../help_content/help_content_components";
export default {
  name: "help_dialog",
  mixins: [bus_common, help_content_components],
  props: ["helpID"],
  data() {
    return {
      dialog: true,
      overlay_loading: false,
      current_help_page_component: null,
      current_help_page_record: null,
    };
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.$emit("closeDialog");
      }, 300);
    },
    async init() {
      if (this.helpID == undefined) {
        console.error("No help content ID found!");
        this.closeDialog();
      } else {
        // Find the correct component name
        this.current_help_page_record = help_content_components.find(
          (x) => x.id == this.helpID
        );

        // Import the correct component
        const help_page_component = await import(
          `../help_content/log_components/${this.current_help_page_record.filename}.vue`
        );

        // Register the component
        this.$options.components[this.current_help_page_record.filename] =
          help_page_component.default;

        // Set current child
        this.current_help_page_component =
          this.current_help_page_record.filename;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
